const SEARCH_ORDER_FALLBACK = 999999;

function normalizeSearchOrder(value: any) {
  const order = Number(value);

  return Number.isFinite(order) && order > 0 ? order : SEARCH_ORDER_FALLBACK;
}

export function getSearchableTramites(tramites: Array<any>) {
  return [...(tramites || [])]
    .filter(
      (tramite: any) =>
        tramite?.show_in_search !== false &&
        tramite?.show_in_search !== 0 &&
        tramite?.show_in_search !== "0"
    )
    .sort((a: any, b: any) => {
      const orderDiff =
        normalizeSearchOrder(a?.search_order) -
        normalizeSearchOrder(b?.search_order);

      if (orderDiff !== 0) {
        return orderDiff;
      }

      return String(a?.name || a?.title || "").localeCompare(
        String(b?.name || b?.title || ""),
        "es"
      );
    });
}
